module.exports = __webpack_public_path__ + "img/icon_user_tuanduiyeji.033ff273.png";